import { twMerge } from 'tailwind-merge';
import { PlusIcon } from '../../icons/PlusIcon';

type AddItemButtonProps = {
  onClick?: () => void;
  className?:string,
  title:string;
};

export const AddItemPlusButton: React.FC<AddItemButtonProps> = ({ onClick, className:externalClassName, title }) => {
  const className = twMerge('group flex w-fit cursor-pointer items-center space-x-1.5', externalClassName);
  
  return (
    <div
      className={className}
      onClick={onClick}
    >
      <PlusIcon className='text-icon group-hover:text-style' />
      <label className="text-icon group-hover:text-style cursor-pointer" >
        {title}
      </label>
    </div>
  );
};